import React from 'react';
import { ReactComponent as Trash } from '../../assets/images/icons/trash.svg';

function TrashIcon(props) {
  return (
    <Trash {...props} className={'icon'} />
  );
}

export default TrashIcon;
